<script setup>
import { Link } from '@inertiajs/vue3'
import { ArrowRight } from 'lucide-vue-next'

defineProps({
  href: { type: String, default: '#' },
  // solid = laranja preenchido; outline = contornado
  variant: { type: String, default: 'solid' },
  icon: { type: [Object, Function], default: null },
})

const styles = {
  solid: 'bg-up-orange text-white hover:bg-up-orange-dark',
  outline: 'border border-up-orange text-up-orange hover:bg-up-orange/5',
}
</script>

<template>
  <Link
    :href="href"
    class="flex w-full items-center justify-center gap-2 rounded-lg px-4 py-3.5 text-sm font-semibold tracking-wide uppercase transition-colors"
    :class="styles[variant]"
  >
    <component :is="icon" v-if="icon" class="h-4 w-4" aria-hidden="true" />
    <slot />
    <ArrowRight class="h-4 w-4" aria-hidden="true" />
  </Link>
</template>
